<template>
    <BreadCrumb PageTitle="Liste des langues" />
    <ListeLangue />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeLangue from "../../components/Langue/ListeLangue.vue";

  
    export default defineComponent({
      name: "ListeLanguePage",
      components: {
        BreadCrumb,
        ListeLangue,
      },
    });
  </script>